import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, DatePicker, Typography } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { useState, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { SummaryDayGridTable } from './daygrid/SummaryDayGridTable';

/**
 * /summary — «Сводка»: the all-stores day grid (cash / terminal / expenses per
 * store) for one month, with per-store totals, the informational terminal
 * commission subtracted, and a grand total. Read-only; month picker like the
 * ledger pages.
 */
export function SummaryPage(): JSX.Element {
  const { t } = useTranslation();
  const [month, setMonth] = useState<Dayjs>(() => dayjs().startOf('month'));

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <Typography.Title level={4} style={{ margin: 0 }}>
        {t('summary.title')}
      </Typography.Title>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <Button icon={<LeftOutlined />} onClick={() => setMonth((m) => m.subtract(1, 'month'))} />
        <DatePicker
          picker="month"
          value={month}
          onChange={(m) => m && setMonth(m.startOf('month'))}
          allowClear={false}
          format="MMMM YYYY"
          style={{ flex: 1 }}
          inputReadOnly
        />
        <Button icon={<RightOutlined />} onClick={() => setMonth((m) => m.add(1, 'month'))} />
      </div>
      <SummaryDayGridTable month={month.format('YYYY-MM')} />
    </div>
  );
}
